module.exports = __webpack_public_path__ + "static/img/leave-dialog.a52bacfc.png";